const prodAssetsUrl = 'https://assets.terveystalo.com';
var assetsUrlOverride;
export function setBaseUrl(newBaseUrl) {
    assetsUrlOverride = newBaseUrl;
}
/**
 * Linaria doesn't support values which can be updated dynamically at all.
 *
 * This means that we need to provide a code path which results in a static
 * value all the time - hence the `staticUrl` property.
 *
 * This would need a better fix for Linaria use case - but ultimately
 * we're only using the dynamic baseUrl for development purposes so this
 * might be "ok" at least for now.
 */
function getBaseUrl(staticUrl) {
    if (staticUrl) {
        return prodAssetsUrl;
    }
    return assetsUrlOverride !== null && assetsUrlOverride !== void 0 ? assetsUrlOverride : prodAssetsUrl;
}
/**
 * Current asset version.
 * Build process will ensure that this always matches the assets version.
 */
const version = 13;
const defaultColors = {
    icons: 'lake',
    pictograms: 'lake',
    logo: 'original',
    smileys: 'coal',
};
/**
 * Constructs the CDN URL for the specified image.
 */
export function imageUrl(set, name, modifiers) {
    const color = (modifiers === null || modifiers === void 0 ? void 0 : modifiers.color) || defaultColors[set];
    return `${getBaseUrl(modifiers === null || modifiers === void 0 ? void 0 : modifiers.staticUrl)}/v${version}/${set}/${color}/${name}.svg`;
}
/**
 * Constructs the CDN URL for the specified store badge image.
 */
export function storeBadgeUrl(store, language) {
    return `${getBaseUrl()}/v${version}/store-badges/${store}/${language}.svg`;
}
/**
 * Constructs the CDN URL for the specified picture file.
 *
 * @param name Name of the base picture
 * @param width Width to use, in pixels, see index or types for available values.
 * @param fileFormat File format to use, usually one of `avif`, `webp` or `jpeg`
 */
export function pictureUrl(name, width, fileFormat) {
    return `${getBaseUrl()}/v${version}/pictures/${name}/${width}w.${fileFormat}`;
}
/**
 * Constructs CDN URL for specified external SVG asset
 *
 * External SVG assets are 3rd party provided icons etc. that do not adhere
 * to Terveystalo design system.
 */
export function externalIconUrl(set, name) {
    return `${getBaseUrl()}/v${version}/${set}/${name}.svg`;
}
/**
 * Constructs CDN URL for the specified multicolor SVG asset
 */
export function multicolorImageUrl(set, name) {
    return `${getBaseUrl()}/v${version}/${set}/${name}.svg`;
}
